import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import { PermissionErrorComponent } from './permission-error.component';

const routes: Routes = [
  {
    path: '',
    component: PermissionErrorComponent 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PermissionErrorRoutingModule {
}
